/**
 * Start time for the processing timer: Event.claimedDateTime when present.
 * Offset-less Dealer DateTime is UTC (including 7-digit fractions).
 *
 * Dealer often emits UTC DateTime without `Z` and with 7-digit fractions.
 * Offset-less values are treated as UTC. Missing or unparseable values fall
 * back to now.
 *
 * TODO: Remove this now-fallback once the claim logic always returns Event.claimedDateTime.
 */
export function resolveProcessingClaimedAt(claimedAt: string | null | undefined): string {
  const trimmed = claimedAt?.trim();
  if (!trimmed) {
    return new Date().toISOString();
  }

  return parseDealerUtcIso(trimmed) ?? new Date().toISOString();
}

const HAS_EXPLICIT_OFFSET = /(?:Z|[+-]\d{2}:?\d{2})$/i;

function parseDealerUtcIso(value: string): string | null {
  const withMillis = value.replace(/(\.\d{3})\d+/, '$1');
  const asUtc = HAS_EXPLICIT_OFFSET.test(withMillis) ? withMillis : `${withMillis}Z`;
  const ms = Date.parse(asUtc);
  return Number.isFinite(ms) ? new Date(ms).toISOString() : null;
}
